import { render, staticRenderFns } from "./MainHeading.vue?vue&type=template&id=0cacadd0&scoped=true&lang=html&"
import script from "./MainHeading.vue?vue&type=script&lang=js&"
export * from "./MainHeading.vue?vue&type=script&lang=js&"
import style0 from "./MainHeading.vue?vue&type=style&index=0&id=0cacadd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cacadd0",
  null
  
)

export default component.exports